<template>
  <nav class="m-tabbar">
    <div class="tb" :class="{ on: currentTab === 'home' }" @click="goTo('home')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
           stroke-linejoin="round">
        <path d="M3 10.5 12 3l9 7.5"/>
        <path d="M5 9.5V20h14V9.5"/>
        <path d="M10 20v-5h4v5"/>
      </svg>
      <span>首页</span>
    </div>
    <div class="tb" :class="{ on: currentTab === 'order' }" @click="goTo('order')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
           stroke-linejoin="round">
        <ellipse cx="12" cy="5" rx="8" ry="3"/>
        <path d="M4 5v6c0 1.66 3.58 3 8 3s8-1.34 8-3V5"/>
        <path d="M4 11v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6"/>
      </svg>
      <span>数据</span>
    </div>
    <div class="tb" :class="{ on: currentTab === 'project' }" @click="goTo('project')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
           stroke-linejoin="round">
        <path d="M11 6h10M11 12h10M11 18h10"/>
        <path d="M3.5 5.5 5 7l2.5-2.5"/>
        <path d="M3.5 11.5 5 13l2.5-2.5"/>
        <path d="M3.5 17.5 5 19l2.5-2.5"/>
      </svg>
      <span>项目</span>
    </div>
    <div class="tb" :class="{ on: currentTab === 'mine' }" @click="goTo('mine')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
           stroke-linejoin="round">
        <circle cx="12" cy="8" r="4"/>
        <path d="M5 21c0-3.9 3.1-7 7-7s7 3.1 7 7"/>
      </svg>
      <span>我的</span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MTabBar',
  computed: {
    currentTab() {
      const path = this.$route.path;
      // 移动端 / PC 路由都高亮对应 tab（数据与项目命名不一致，需分别匹配）
      if (path === '/m/home' || path === '/home') return 'home';
      if (path === '/m/order' || path === '/recordList') return 'order';
      if (path === '/m/project' || path === '/projectList') return 'project';
      if (path === '/m/mine') return 'mine';
      return '';
    },
    isMobile() {
      // 与路由守卫保持一致：优先用 sessionStorage 标记，缺失时按宽度兜底
      const flag = sessionStorage.getItem('isMobile');
      if (flag !== null) return flag === 'true';
      return (window.innerWidth || 0) <= 768;
    }
  },
  methods: {
    goTo(tab) {
      // 移动端 / PC 使用各自对应的路由，保证切换设备后落到的都是真实存在的页面
      const paths = this.isMobile
        ? { home: '/m/home', order: '/m/order', project: '/m/project', mine: '/m/mine' }
        : { home: '/home', order: '/recordList', project: '/projectList', mine: '/home' };
      this.$router.push(paths[tab]);
    }
  }
};
</script>

<style scoped>
.m-tabbar {
  --primary: #12b3a8;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  flex: none;
  height: 56px;
  background: #fff;
  border-top: .5px solid var(--line);
  display: flex;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 10;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0
}

.tb {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: var(--t3);
  position: relative;
  cursor: pointer
}

.tb svg {
  width: 22px;
  height: 22px
}

.tb span {
  font-size: 10.5px
}

.tb.on {
  color: var(--primary)
}

.tb.on span {
  font-weight: 600
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MTabBar.vue